export default __webpack_public_path__ + "static/media/ic_Group.a9d86e28.svg";